export function csrfHeader() {
    const csrfToken = localStorage.getItem('currentToken');

    if (csrfToken) {
        return { 'Csrf-Token': csrfToken };
    }

    return {};
}
